var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInst = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 31,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15.632,
  r: 15,
  fill: "#3D3D3D"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#13AD37",
  d: "M21.71 12.861a4.896 4.896 0 0 0-.314-1.662 3.458 3.458 0 0 0-1.974-1.974 4.954 4.954 0 0 0-1.64-.315c-.721-.033-.95-.042-2.782-.042-1.831 0-2.066 0-2.782.042a4.955 4.955 0 0 0-1.639.315 3.455 3.455 0 0 0-1.975 1.974 4.915 4.915 0 0 0-.314 1.639c-.032.722-.042.951-.042 2.783 0 1.831 0 2.065.042 2.782.011.561.117 1.114.314 1.64a3.458 3.458 0 0 0 1.976 1.974 4.939 4.939 0 0 0 1.639.338c.722.032.95.042 2.782.042s2.066 0 2.783-.042a4.943 4.943 0 0 0 1.639-.314 3.46 3.46 0 0 0 1.975-1.975 4.94 4.94 0 0 0 .314-1.64c.032-.722.042-.95.042-2.783-.002-1.832-.002-2.064-.044-2.782Zm-6.714 6.223a3.466 3.466 0 1 1-.002-6.933 3.466 3.466 0 0 1 .002 6.933ZM18.6 12.83a.807.807 0 1 1-.002-1.615.807.807 0 0 1 .002 1.615Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#13AD37",
  d: "M14.994 17.869a2.252 2.252 0 1 0 0-4.505 2.252 2.252 0 0 0 0 4.505Z"
})));
export default SvgInst;